module.exports = __webpack_public_path__ + "static/colormatics-social-aa08bbba1ccc7ebd8a14bae54e43ce9a.jpg";